// import { VisionStudioTabs } from "../../components";
import React, { useState } from "react";
import {
  Box,
  Button,
  Link,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import videoThumbnail from "../../assets/img/videopic.png";

/**
 *
 * Componet to display Home page UI.
 *
 */

const DetailVideo: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);

  // Handle opening the dialog
  const handleClickOpen = () => {
    setOpen(true);
    localStorage.setItem("popupOpen", true.toString());
  };

  // Handle closing the dialog
  const handleClose = () => {
    setOpen(false);
    localStorage.setItem("popupOpen", false.toString());
  };
  return (
    <Box
      sx={{
        background: "white",
        borderRadius: "6px",
        padding: "10px",
        flex: "0 0 40%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        variant="h2"
        sx={{ fontSize: "18px", fontWeight: "600", lineHeight: "40px" }}
      >
        Need a Quick Guide? Watch Our Walkthrough!
      </Typography>
      <Box>
        <Typography
          sx={{ color: "#5B6871", lineHeight: "20px", fontSize: "16px" }}
        >
          Master the platform in minutes—
          <Link>set up projects, train models, and unlock advanced tools.</Link>
        </Typography>
      </Box>

      <Box
        sx={{
          boxShadow: "0px 0px 5px 0px #8a929b47",
          background: "#F3FBFF",
          borderRadius: "12px",
          padding: "13px",
          marginTop: "4%",
          // display: "flex",
          gap: "10px",
          alignItems: "center",
          flex: "1",
          display: "flex",
          flexDirection: "column",
          overflow: "scroll",
          maxHeight: "calc(100vh - 387px)",
          paddingBottom: "0px !Important",
        }}
      >
        <Box
          sx={{
            flex: "1",
            display: "flex",
            // alignItems: "center",
            gap: "15px",
            marginBottom: "10px",
            alignSelf: "self-start",
            maxHeight: "fit-content",
          }}
        >
          <Typography>
            <span style={{ fontSize: "24px", fontWeight: "500" }}>
              Optimize Your Workflow{" "}
            </span>
            <br></br>
            <span>Explore Features</span>
          </Typography>
          <Button
            id="watchNowButton"
            variant="contained"
            sx={{ alignItems: "self-start", gap: "5px", height: "fit-content" }}
            onClick={handleClickOpen}
          >
            Watch Now <PlayCircleOutlineIcon />
          </Button>
        </Box>
        <video
          onClick={handleClickOpen}
          style={{
            width: "100%",
            flex: "0 0 60%",
            cursor: "pointer",
            flexGrow: "1",
          }}
          poster={videoThumbnail}
        >
          <source src="" type="video/mp4" />
        </video>
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
          <DialogTitle>Watch Video</DialogTitle>
          <DialogContent id="workFlowVidoe" sx={{ overflow: "hidden" }}>
            {/* Video content */}
            <iframe
              title="youtube"
              width="100%"
              height="400"
              src="https://www.youtube.com/embed/fmszZsq6CFc?autoplay=1&mute=1"
              style={{ border: "0" }}
            ></iframe>
          </DialogContent>
          <DialogActions>
            <Button id="closePopup" onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default DetailVideo;
